import React, { cloneElement } from 'react';
import GridItem from 'components/elements/common/griditem/GridItem';

import './StoryGridItem.scss';

const StoryGridItem = props => (
  <GridItem
    {...props}
    className={`news-grid-item ${props.className}`}
    contents={cloneElement(props.contents, { ...props })}
    actions={cloneElement(props.actions, { ...props })}
  />
);

export default StoryGridItem;
